import { render, staticRenderFns } from "./ImproveSystem.vue?vue&type=template&id=08c7a40e&"
import script from "./ImproveSystem.vue?vue&type=script&lang=js&"
export * from "./ImproveSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports